import axios from "axios";
import store from '../store'
//import Vue from "vue";

// let baseUrl = 'https://api.sum.ba/registar_v2'

export default {
    fetchRad(params) {
        return axios.get(`/registar_v2/radovi/${params}`, {
            params: {
                with: ['linkovi', 'straniAutori', 'uposleniciAutori', 'izdanje', 'linkovi', 'vrstaRada',
                    'znanstvenaPodrucja', 'kljucneRijeci', 'prijevodi', 'studentiAutori', 'autori', 'dokumentiRada']
            }
        }).then((res) => {
            let resCode = res.status
            switch (resCode) {
                case 200:
                    return res.data
                case 201:
                    return res.data
                case 204:
                    return res.data
                case 404:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Dogodila se greška, molimo pokušajte ponovno za par trenutaka'
                    })
                    break
                case 500:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Došlo je do greške na poslužitelju, molimo pokušajte ponovno'
                    })
                    break
                default:
                    return res.data
            }
        })
    },
    fetchIzdanje(params) {
        return axios.get(`/registar_v2/izdanja/${params}`, {
            params: {
                with: ['Izdavaci', 'bazeIzdanja']
            }
        }).then((res) => {
            let resCode = res.status
            switch (resCode) {
                case 200:
                    return res.data
                case 201:
                    return res.data
                case 204:
                    return res.data
                case 404:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Dogodila se greška, molimo pokušajte ponovno za par trenutaka'
                    })
                    break
                case 500:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Došlo je do greške na poslužitelju, molimo pokušajte ponovno'
                    })
                    break
                default:
                    return res.data
            }
        })
    },
    fetchUposlenik(params) {
        return axios.get(`/uposlenici/${params}`, {
            params: {
                with: ['znanstveniRadovi']
            }
        }).then((res) => {
            let resCode = res.status
            switch (resCode) {
                case 200:
                    return res.data
                case 201:
                    return res.data
                case 204:
                    return res.data
                case 404:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Dogodila se greška, molimo pokušajte ponovno za par trenutaka'
                    })
                    break
                case 500:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Došlo je do greške na poslužitelju, molimo pokušajte ponovno'
                    })
                    break
                default:
                    return res.data
            }
        })
    },
    fetchOsoba(params) {
        return axios.get(`/osobe/${params}`, {
            params: {
                with: ['znanstveniRadovi']
            }
        }).then((res) => {
            let resCode = res.status
            switch (resCode) {
                case 200:
                    return res.data
                case 201:
                    return res.data
                case 204:
                    return res.data
                case 404:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Dogodila se greška, molimo pokušajte ponovno za par trenutaka'
                    })
                    break
                case 500:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Došlo je do greške na poslužitelju, molimo pokušajte ponovno'
                    })
                    break
                default:
                    return res.data
            }
        })
    },
    fetchStraniAutor(params) {
        return axios.get(`/registar_v2/strani_autori/${params}`, {
            params: {
                with: ['znanstveniRadovi']
            }
        }).then((res) => {
            let resCode = res.status
            switch (resCode) {
                case 200:
                    return res.data
                case 201:
                    return res.data
                case 204:
                    return res.data
                case 404:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Dogodila se greška, molimo pokušajte ponovno za par trenutaka'
                    })
                    break
                case 500:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Došlo je do greške na poslužitelju, molimo pokušajte ponovno'
                    })
                    break
                default:
                    return res.data
            }
        })
    },
    getRegistar(params) {
        return axios.get('/registar_v2/radovi?page=' + params.page + '&filter[naslov]=~=' + params.search + '&filter[verificiran]=~=' + params.verificiran, {
            params: {
                with: ['straniAutori', 'uposleniciAutori', 'vrstaRada', 'studentiAutori', 'autori', 'dokumentiRada']
            }
        }).then((res) => {
            let resCode = res.status
            switch (resCode) {
                case 200:
                    return res.data
                case 201:
                    return res.data
                case 204:
                    return res.data
                case 404:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Dogodila se greška, molimo pokušajte ponovno za par trenutaka'
                    })
                    break
                case 500:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Došlo je do greške na poslužitelju, molimo pokušajte ponovno'
                    })
                    break
                default:
                    return res.data
            }
        })
    },
    getRegistarTypes(page) {
        return axios.get('/registar_v2/vrste_rada?filter[tip_id]=n=&with[]=vrsteRada&with[]=tipIzdanja&page=' + page).then((res) => {
            let resCode = res.status
            switch (resCode) {
                case 200:
                    return res.data
                case 201:
                    return res.data
                case 204:
                    return res.data
                case 404:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Dogodila se greška, molimo pokušajte ponovno za par trenutaka'
                    })
                    break
                case 500:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Došlo je do greške na poslužitelju, molimo pokušajte ponovno'
                    })
                    break
                default:
                    return res.data
            }
        })
    },
    getRegistarDocuments() {
        return axios.get('/registar_v2/dokumenti_rada').then((res) => {
            let resCode = res.status
            switch (resCode) {
                case 200:
                    return res.data
                case 201:
                    return res.data
                case 204:
                    return res.data
                case 404:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Dogodila se greška, molimo pokušajte ponovno za par trenutaka'
                    })
                    break
                case 500:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Došlo je do greške na poslužitelju, molimo pokušajte ponovno'
                    })
                    break
                default:
                    return res.data
            }
        })
    },
    getRegistarKeywords(search) {
        return axios.get('/registar_v2/kljucne_rijeci?search=' + search).then((res) => {
            let resCode = res.status
            switch (resCode) {
                case 200:
                    return res.data
                case 201:
                    return res.data
                case 204:
                    return res.data
                case 404:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Dogodila se greška, molimo pokušajte ponovno za par trenutaka'
                    })
                    break
                case 500:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Došlo je do greške na poslužitelju, molimo pokušajte ponovno'
                    })
                    break
                default:
                    return res.data
            }
        })
    },
    getRegistarEditions() {
        return axios.get('/registar_v2/izdanja').then((res) => {
            let resCode = res.status
            switch (resCode) {
                case 200:
                    return res.data
                case 201:
                    return res.data
                case 204:
                    return res.data
                case 404:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Dogodila se greška, molimo pokušajte ponovno za par trenutaka'
                    })
                    break
                case 500:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Došlo je do greške na poslužitelju, molimo pokušajte ponovno'
                    })
                    break
                default:
                    return res.data
            }
        })
    },
    createNewDatabaseEdition(naziv) {
        return axios.post('/registar_v2/baze_izdanja', {
            naziv: naziv,
        }).then((res) => {
            let resCode = res.status
            switch (resCode) {
                case 200:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'green',
                        text: 'Baza izdanja uspješno dodana'
                    })
                    return res.data
                case 201:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'green',
                        text: 'Baza izdanja uspješno dodana'
                    })
                    return res.data
                case 204:
                    return res.data
                case 404:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Dogodila se greška, molimo pokušajte ponovno za par trenutaka'
                    })
                    break
                case 500:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Došlo je do greške na poslužitelju, molimo pokušajte ponovno'
                    })
                    break
                default:
                    return res.data
            }
        })
    },
    editNewDatabaseEdition(edition) {
        return axios.put(`/registar_v2/baze_izdanja/${edition.id}`, {
            naziv: edition.naziv,
        }).then((res) => {
            let resCode = res.status
            switch (resCode) {
                case 200:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'green',
                        text: 'Baza izdanja uspješno uređena'
                    })
                    return res.data
                case 201:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'green',
                        text: 'Baza izdanja uspješno uređena'
                    })
                    return res.data
                case 204:
                    return res.data
                case 404:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Dogodila se greška, molimo pokušajte ponovno za par trenutaka'
                    })
                    break
                case 500:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Došlo je do greške na poslužitelju, molimo pokušajte ponovno'
                    })
                    break
                default:
                    return res.data
            }
        })
    },
    getRegistarEditionDatabases(params) {
        return axios.get('/registar_v2/baze_izdanja?page=' + params.page + '&filter[naziv]=~=' + params.search).then((res) => {
            let resCode = res.status
            switch (resCode) {
                case 200:
                    return res.data
                case 201:
                    return res.data
                case 204:
                    return res.data
                case 404:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Dogodila se greška, molimo pokušajte ponovno za par trenutaka'
                    })
                    break
                case 500:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Došlo je do greške na poslužitelju, molimo pokušajte ponovno'
                    })
                    break
                default:
                    return res.data
            }
        })
    },
    getAllBaze() {
        return axios.get('/registar_v2/baze_izdanja?perPage=-1').then((res) => {
            let resCode = res.status
            switch (resCode) {
                case 200:
                    return res.data
                case 201:
                    return res.data
                case 204:
                    return res.data
                case 404:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Dogodila se greška, molimo pokušajte ponovno za par trenutaka'
                    })
                    break
                case 500:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Došlo je do greške na poslužitelju, molimo pokušajte ponovno'
                    })
                    break
                default:
                    return res.data
            }
        })
    },
    getRegistarForeignAuthors(search) {
        return axios.get('/registar_v2/strani_autori?search=' + search).then((res) => {
            let resCode = res.status
            switch (resCode) {
                case 200:
                    return res.data
                case 201:
                    return res.data
                case 204:
                    return res.data
                case 404:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Dogodila se greška, molimo pokušajte ponovno za par trenutaka'
                    })
                    break
                case 500:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Došlo je do greške na poslužitelju, molimo pokušajte ponovno'
                    })
                    break
                default:
                    return res.data
            }
        })
    },
    getRegistarTypesFilter(search) {
        return axios.get('/registar_v2/vrste_rada?filter[tip_id]=n=&with[]=vrsteRada&with[]=tipIzdanja&search=' + search).then((res) => {
            let resCode = res.status
            switch (resCode) {
                case 200:
                    return res.data
                case 201:
                    return res.data
                case 204:
                    return res.data
                case 404:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Dogodila se greška, molimo pokušajte ponovno za par trenutaka'
                    })
                    break
                case 500:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Došlo je do greške na poslužitelju, molimo pokušajte ponovno'
                    })
                    break
                default:
                    return res.data
            }
        })
    },
    getScientificFields(search) {
        return axios.get('/znanstvena_podrucja?search=' + search).then((res) => {
            let resCode = res.status
            switch (resCode) {
                case 200:
                    return res.data
                case 201:
                    return res.data
                case 204:
                    return res.data
                case 404:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Dogodila se greška, molimo pokušajte ponovno za par trenutaka'
                    })
                    break
                case 500:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Došlo je do greške na poslužitelju, molimo pokušajte ponovno'
                    })
                    break
                default:
                    return res.data
            }
        })
    },
    // createNewVrstaRada(params) {
    //     return axios.post('/registar_v2/vrste_rada', {
    //         naziv: params.naziv,
    //         tip_id: params.tipId
    //     }).then((res) => {
    //         let resCode = res.status
    //         switch (resCode){
    //             case 200:
    //                 dispatch('getNotification',{
    //                     state: true,
    //                     color: 'green',
    //                     text:'Vrsta rada uspješno dodana'
    //                 })
    //             case 201:
    //                 dispatch('getNotification',{
    //                     state: true,
    //                     color: 'green',
    //                     text:'Vrsta rada uspješno dodana'
    //                 })
    //             case 204:
    //                 return res.data
    //             case 404:
    //                 store.dispatch('getNotification',{
    //                     state: true,
    //                     color: 'red',
    //                     text:'Ups! Dogodila se greška, molimo pokušajte ponovno za par trenutaka'
    //                 })
    //                 break
    //             case 500:
    //                 store.dispatch('getNotification',{
    //                     state: true,
    //                     color: 'red',
    //                     text:'Došlo je do greške na poslužitelju, molimo pokušajte ponovno'
    //                 })
    //                 break
    //             default:
    //                 return res.data
    //         }
    //     })
    // },
    getJezici(search) {
        search = search ? search : ''
        return axios.get('/jezici?perPage=-1&filter[naziv]=~=' + search).then((res) => {
            let resCode = res.status
            switch (resCode) {
                case 200:
                    return res.data
                case 201:
                    return res.data
                case 204:
                    return res.data
                case 404:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Dogodila se greška, molimo pokušajte ponovno za par trenutaka'
                    })
                    break
                case 500:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Došlo je do greške na poslužitelju, molimo pokušajte ponovno'
                    })
                    break
                default:
                    return res.data
            }
        })
    },
    getOsobe(search) {
        return axios.get(`/osobe?search=${search}`).then((res) => {
            let resCode = res.status
            switch (resCode) {
                case 200:
                    return res.data
                case 201:
                    return res.data
                case 204:
                    return res.data
                case 404:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Dogodila se greška, molimo pokušajte ponovno za par trenutaka'
                    })
                    break
                case 500:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Došlo je do greške na poslužitelju, molimo pokušajte ponovno'
                    })
                    break
                default:
                    return res.data
            }
        })
    },
    getZvanja(search) {
        return axios.get(`/zvanja?search=${search}`).then((res) => {
            let resCode = res.status
            switch (resCode) {
                case 200:
                    return res.data
                case 201:
                    return res.data
                case 204:
                    return res.data
                case 404:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Dogodila se greška, molimo pokušajte ponovno za par trenutaka'
                    })
                    break
                case 500:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Došlo je do greške na poslužitelju, molimo pokušajte ponovno'
                    })
                    break
                default:
                    return res.data
            }
        })
    },
    getAkademskiStupnjevi(search) {
        return axios.get(`/akademski_stupnjevi?search=${search}`).then((res) => {
            let resCode = res.status
            switch (resCode) {
                case 200:
                    return res.data
                case 201:
                    return res.data
                case 204:
                    return res.data
                case 404:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Dogodila se greška, molimo pokušajte ponovno za par trenutaka'
                    })
                    break
                case 500:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Došlo je do greške na poslužitelju, molimo pokušajte ponovno'
                    })
                    break
                default:
                    return res.data
            }
        })
    },
    getUposlenici(search) {
        if (search) {
            return axios.get(`/uposlenici?search=${search}`,{params: {
                with: ['znanstveniRadovi']
            }}).then((res) => {
                let resCode = res.status
                switch (resCode) {
                    case 200:
                        return res.data
                    case 201:
                        return res.data
                    case 204:
                        return res.data
                    case 404:
                        store.dispatch('getNotification', {
                            state: true,
                            color: 'red',
                            text: 'Dogodila se greška, molimo pokušajte ponovno za par trenutaka'
                        })
                        break
                    case 500:
                        store.dispatch('getNotification', {
                            state: true,
                            color: 'red',
                            text: 'Došlo je do greške na poslužitelju, molimo pokušajte ponovno'
                        })
                        break
                    default:
                        return res.data
                }
            })
        } else {
            return axios.get(`/uposlenici`,{params: {
                with: ['znanstveniRadovi']
            }}).then((res) => {
                let resCode = res.status
                switch (resCode) {
                    case 200:
                        return res.data
                    case 201:
                        return res.data
                    case 204:
                        return res.data
                    case 404:
                        store.dispatch('getNotification', {
                            state: true,
                            color: 'red',
                            text: ' Dogodila se greška, molimo pokušajte ponovno za par trenutaka'
                        })
                        break
                    case 500:
                        store.dispatch('getNotification', {
                            state: true,
                            color: 'red',
                            text: 'Došlo je do greške na poslužitelju, molimo pokušajte ponovno'
                        })
                        break
                    default:
                        return res.data
                }
            })
        }
    },
    getAkademskoOsoblje(params, ) {
        return axios.get(`/uposlenici?page=${params.item}&search=${params.search}`,{params: {
            with: ['znanstveniRadovi']
        }}).then((res) => {
            let resCode = res.status
            switch (resCode) {
                case 200:
                    return res.data
                case 201:
                    return res.data
                case 204:
                    return res.data
                case 404:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Dogodila se greška, molimo pokušajte ponovno za par trenutaka'
                    })
                    break
                case 500:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Došlo je do greške na poslužitelju, molimo pokušajte ponovno'
                    })
                    break
                default:
                    return res.data
            }
        })
    },
    getStudenti(params) {
        return axios.get(`/osobe?page=${params.item}&search=${params.search}`,{params: {
            with: ['znanstveniRadovi']
        }}).then((res) => {
            let resCode = res.status
            switch (resCode) {
                case 200:
                    return res.data
                case 201:
                    return res.data
                case 204:
                    return res.data
                case 404:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Dogodila se greška, molimo pokušajte ponovno za par trenutaka'
                    })
                    break
                case 500:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Došlo je do greške na poslužitelju, molimo pokušajte ponovno'
                    })
                    break
                default:
                    return res.data
            }
        })
    },
    createNewStraniAutor(autor) {
        return axios.post('/registar_v2/strani_autori', {
            ime: autor.ime,
            prezime: autor.prezime,
            zvanje_id: autor.zvanje_id,
            akad_stupanj_id: autor.akad_stupanj_id,
            organizacija: autor.organizacija,
            sifra: autor.sifra
        }).then(res => {
            let resCode = res.status
            switch (resCode) {
                case 200:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'green',
                        text: 'Strani autor je uspješno dodan'
                    })
                    return res.data
                case 201:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'green',
                        text: 'Strani autor je uspješno dodan'
                    })
                    return res.data
                case 204:
                    return res.data
                case 404:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Dogodila se greška, molimo pokušajte ponovno za par trenutaka'
                    })
                    break
                case 500:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Došlo je do greške na poslužitelju, molimo pokušajte ponovno'
                    })
                    break
                default:
                    return res.data
            }
        })
    },
    editStraniAuthor(autor) {
        let id = autor.id ? autor.id : ''
        return axios.put(`/registar_v2/strani_autori/${id}`, {
            ime: autor.ime,
            prezime: autor.prezime,
            zvanje_id: autor.zvanje_id,
            akad_stupanj_id: autor.akad_stupanj_id,
            organizacija: autor.organizacija,
            sifra: autor.sifra
        }).then(res => {
            let resCode = res.status
            switch (resCode) {
                case 200:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'green',
                        text: 'Strani autor je uspješno uređen'
                    })
                    return res.data
                case 201:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'green',
                        text: 'Strani autor je uspješno uređen'
                    })
                    return res.data
                case 204:
                    return res.data
                case 404:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Dogodila se greška, molimo pokušajte ponovno za par trenutaka'
                    })
                    break
                case 500:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Došlo je do greške na poslužitelju, molimo pokušajte ponovno'
                    })
                    break
                default:
                    return res.data
            }
        })
    },
    createNewKljucnaRijec(rijec) {
        return axios.post('/registar_v2/kljucne_rijeci', {
            naziv: rijec
        }).then(res => {
            let resCode = res.status
            switch (resCode) {
                case 200:
                    return res.data
                case 201:
                    return res.data
                case 204:
                    return res.data
                case 404:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Dogodila se greška, molimo pokušajte ponovno za par trenutaka'
                    })
                    break
                case 500:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Došlo je do greške na poslužitelju, molimo pokušajte ponovno'
                    })
                    break
                default:
                    return res.data

            }
        })
    },
    kreirajNoviJezik(jezik) {
        return axios.post('/jezici', { naziv: jezik }).then(res => {
            let resCode = res.status
            switch (resCode) {
                case 200:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'green',
                        text: 'Novi jezik je uspješno dodan'
                    })
                    return res.data
                case 201:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'green',
                        text: 'Novi jezik je uspješno dodan'
                    })
                    return res.data
                case 204:
                    return res.data
                case 404:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Dogodila se greška, molimo pokušajte ponovno za par trenutaka'
                    })
                    break
                case 500:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Došlo je do greške na poslužitelju, molimo pokušajte ponovno'
                    })
                    break
                default:
                    return res.data

            }
        })
    },
    getStraniAutori(params) {
        return axios.get(`/registar_v2/strani_autori?page=${params.page}&filter[ime]=~=${params.search}`,{
            params: {
                with: ['znanstveniRadovi']
            }
        }).then((res) => {
            let resCode = res.status
            switch (resCode) {
                case 200:
                    return res.data
                case 201:
                    return res.data
                case 204:
                    return res.data
                case 404:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Dogodila se greška, molimo pokušajte ponovno za par trenutaka'
                    })
                    break
                case 500:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Došlo je do greške na poslužitelju, molimo pokušajte ponovno'
                    })
                    break
                default:
                    return res.data
            }
        })
    },
    getCountries() {
        return axios.get(`/drzave?perPage=-1`).then((res) => {
            let resCode = res.status
            switch (resCode) {
                case 200:
                    return res.data
                case 201:
                    return res.data
                case 204:
                    return res.data
                case 404:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Dogodila se greška, molimo pokušajte ponovno za par trenutaka'
                    })
                    break
                case 500:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Došlo je do greške na poslužitelju, molimo pokušajte ponovno'
                    })
                    break
                default:
                    return res.data
            }
        })
    },
    getIzdavaci(params) {
        return axios.get(`/registar_v2/izdavaci?page=${params.page}&filter[naziv]=~=${params.search}`
        ).then((res) => {
            let resCode = res.status
            switch (resCode) {
                case 200:
                    return res.data
                case 201:
                    return res.data
                case 204:
                    return res.data
                case 404:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Dogodila se greška, molimo pokušajte ponovno za par trenutaka'
                    })
                    break
                case 500:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Došlo je do greške na poslužitelju, molimo pokušajte ponovno'
                    })
                    break
                default:
                    return res.data
            }
        })
    },
    getAllIzdavaci() {
        return axios.get(`/registar_v2/izdavaci?perPage=-1`).then((res) => {
            let resCode = res.status
            switch (resCode) {
                case 200:
                    return res.data
                case 201:
                    return res.data
                case 204:
                    return res.data
                case 404:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Dogodila se greška, molimo pokušajte ponovno za par trenutaka'
                    })
                    break
                case 500:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Došlo je do greške na poslužitelju, molimo pokušajte ponovno'
                    })
                    break
                default:
                    return res.data
            }
        })
    },
    createNewPublisher(izdavac) {
        return axios.post('/registar_v2/izdavaci', { naziv: izdavac.naziv, drzava_id: izdavac.drzava_id }).then(res => {
            let resCode = res.status
            switch (resCode) {
                case 200:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'green',
                        text: 'Novi izdavač je uspješno dodan'
                    })
                    return res.data
                case 201:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'green',
                        text: 'Novi izdavač je uspješno dodan'
                    })
                    return res.data
                case 204:
                    return res.data
                case 404:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Dogodila se greška, molimo pokušajte ponovno za par trenutaka'
                    })
                    break
                case 500:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Došlo je do greške na poslužitelju, molimo pokušajte ponovno'
                    })
                    break
                default:
                    return res.data

            }
        })
    },
    editPublisher(izdavac) {
        return axios.put(`/registar_v2/izdavaci/${izdavac.id}`, { naziv: izdavac.naziv, drzava_id: izdavac.drzava_id }).then(res => {
            let resCode = res.status
            switch (resCode) {
                case 200:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'green',
                        text: 'Izdavač je uspješno uređen'
                    })
                    return res.data
                case 201:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'green',
                        text: 'Izdavač je uspješno uređen'
                    })
                    return res.data
                case 204:
                    return res.data
                case 404:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Dogodila se greška, molimo pokušajte ponovno za par trenutaka'
                    })
                    break
                case 500:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Došlo je do greške na poslužitelju, molimo pokušajte ponovno'
                    })
                    break
                default:
                    return res.data

            }
        })
    },

    deleteDokument(fileId) {
        return axios.delete(`/registar_v2/dokumenti_rada/${fileId}`).then(res => {
            let resCode = res.status
            switch (resCode) {
                case 200:
                    return res.data
                case 201:
                    return res.data
                case 204:
                    return res.data
                case 404:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Dogodila se greška, molimo pokušajte ponovno za par trenutaka'
                    })
                    break
                case 500:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Došlo je do greške na poslužitelju, molimo pokušajte ponovno'
                    })
                    break
                default:
                    return res.data

            }
        })
    },
    deletePublisher(izdavac) {
        return axios.delete(`/registar_v2/izdavaci/${izdavac}`).then(res => {
            let resCode = res.status
            switch (resCode) {
                case 200:
                    return res.data
                case 201:
                    return res.data
                case 204:
                    return res.data
                case 404:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Dogodila se greška, molimo pokušajte ponovno za par trenutaka'
                    })
                    break
                case 500:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Došlo je do greške na poslužitelju ili odabrani izdavač pripada nekom postojećem izdanju'
                    })
                    break
                default:
                    return res.data

            }
        })
    },
    deleteForeignAuthor(autor) {
        return axios.delete(`/registar_v2/strani_autori/${autor}`).then(res => {
            let resCode = res.status
            switch (resCode) {
                case 200:
                    return res.data
                case 201:
                    return res.data
                case 204:
                    return res.data
                case 404:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Dogodila se greška, molimo pokušajte ponovno za par trenutaka'
                    })
                    break
                case 500:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Došlo je do greške na poslužitelju ili je odabrana osoba autor nekog postojećeg rada'
                    })
                    break
                default:
                    return res.data

            }
        })
    },
    deleteEditionDatabase(baza) {
        return axios.delete(`/registar_v2/baze_izdanja/${baza}`).then(res => {
            let resCode = res.status
            switch (resCode) {
                case 200:
                    return res.data
                case 201:
                    return res.data
                case 204:
                    return res.data
                case 404:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Dogodila se greška, molimo pokušajte ponovno za par trenutaka'
                    })
                    break
                case 500:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Došlo je do greške na poslužitelju ili odabrana baza izdanja pripada nekom postojećem izdanju'
                    })
                    break
                default:
                    return res.data

            }
        })
    },
    getIzdanja(params) {
        return axios.get(`/registar_v2/izdanja?page=${params.page}&filter[naziv]=~=${params.search}`).then((res) => {
            let resCode = res.status
            switch (resCode) {
                case 200:
                    return res.data
                case 201:
                    return res.data
                case 204:
                    return res.data
                case 404:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Dogodila se greška, molimo pokušajte ponovno za par trenutaka'
                    })
                    break
                case 500:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Došlo je do greške na poslužitelju, molimo pokušajte ponovno'
                    })
                    break
                default:
                    return res.data
            }
        })
    },
    getIzdanjaByTip(params) {
        return axios.get(`/registar_v2/izdanja?filter[tip_izdanja_id]=~=${params.id}&perPage=-1`).then((res) => {
            let resCode = res.status
            switch (resCode) {
                case 200:
                    return res.data
                case 201:
                    return res.data
                case 204:
                    return res.data
                case 404:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Dogodila se greška, molimo pokušajte ponovno za par trenutaka'
                    })
                    break
                case 500:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Došlo je do greške na poslužitelju, molimo pokušajte ponovno'
                    })
                    break
                default:
                    return res.data
            }
        })
    },
    getFileById(params) {
        return axios.get(`/files/${params.id}`).then((res) => {
            let resCode = res.status
            switch (resCode) {
                case 200:
                    return res.data
                case 201:
                    return res.data
                case 204:
                    return res.data
                case 404:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: ' Dogodila se greška, molimo pokušajte ponovno za par trenutaka'
                    })
                    break
                case 500:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Došlo je do greške na poslužitelju, molimo pokušajte ponovno'
                    })
                    break
                default:
                    return res.data
            }
        })
    },
    createNewIzdanje(izdanje) {
        return axios.post('/registar_v2/izdanja', {
            naziv: izdanje.naziv,
            selectedTip: izdanje.selectedTip,
            issn: izdanje.issn,
            isbn: izdanje.isbn,
            broj: izdanje.broj,
            mjesto_izdavanja: izdanje.mjesto_izdavanja,
            urednik: izdanje.urednik,
            relevantnost: izdanje.relevantnost,
            znanstvena_publikacija: izdanje.znanstvena_publikacija,
            tip_izdanja_id: izdanje.tip_izdanja_id,
            relations: izdanje.relations
        }).then(res => {
            let resCode = res.status
            switch (resCode) {
                case 200:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'green',
                        text: 'Novo izdanje je uspješno dodano'
                    })
                    return res.data
                case 201:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'green',
                        text: 'Novo izdanje je uspješno dodano'
                    })
                    return res.data
                case 204:
                    return res.data
                case 404:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Dogodila se greška, molimo pokušajte ponovno za par trenutaka'
                    })
                    break
                case 500:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Došlo je do greške na poslužitelju, molimo pokušajte ponovno'
                    })
                    break
                default:
                    return res.data

            }
        })
    },
    editIzdanje(izdanje) {
        return axios.put(`/registar_v2/izdanja/${izdanje.id}`, {
            naziv: izdanje.naziv,
            selectedTip: izdanje.selectedTip,
            issn: izdanje.issn,
            isbn: izdanje.isbn,
            broj: izdanje.broj,
            mjesto_izdavanja: izdanje.mjesto_izdavanja,
            urednik: izdanje.urednik,
            relevantnost: izdanje.relevantnost,
            znanstvena_publikacija: izdanje.znanstvena_publikacija,
            tip_izdanja_id: izdanje.tip_izdanja_id,
            relations: izdanje.relations

        }).then(res => {
            let resCode = res.status
            switch (resCode) {
                case 200:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'green',
                        text: 'Izdanje je uspješno uređeno'
                    })
                    return res.data
                case 201:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'green',
                        text: 'Izdanje je uspješno uređeno'
                    })
                    return res.data
                case 204:
                    return res.data
                case 404:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Dogodila se greška, molimo pokušajte ponovno za par trenutaka'
                    })
                    break
                case 500:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Došlo je do greške na poslužitelju, molimo pokušajte ponovno'
                    })
                    break
                default:
                    return res.data

            }
        })
    },
    deleteIzdanje(izdanje) {
        return axios.delete(`/registar_v2/izdanja/${izdanje}`).then(res => {
            let resCode = res.status
            switch (resCode) {
                case 200:
                    return res.data
                case 201:
                    return res.data
                case 204:
                    return res.data
                case 404:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Dogodila se greška, molimo pokušajte ponovno za par trenutaka'
                    })
                    break
                case 500:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Došlo je do greške na poslužitelju ili je odabrano izdanje izdanje nekog postojećeg rada'
                    })
                    break
                default:
                    return res.data

            }
        })
    },
    getTipoviIzdanja() {
        return axios.get(`/registar_v2/tipovi_izdanja?perPage=-1`).then((res) => {
            let resCode = res.status
            switch (resCode) {
                case 200:
                    return res.data
                case 201:
                    return res.data
                case 204:
                    return res.data
                case 404:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Dogodila se greška, molimo pokušajte ponovno za par trenutaka'
                    })
                    break
                case 500:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Došlo je do greške na poslužitelju, molimo pokušajte ponovno'
                    })
                    break
                default:
                    return res.data
            }
        })
    },
    createNewRad(rad) {
        // Object.assign(rad, {formData: files})
        return axios.post('/registar_v2/radovi',
            rad
        ).then(res => {
            let resCode = res.status
            switch (resCode) {
                case 200:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'green',
                        text: 'Rad uspješno dodan'
                    })
                    return res.data
                case 201:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'green',
                        text: 'Rad uspješno dodan'
                    })
                    return res.data
                case 204:
                    return res.data
                case 404:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Dogodila se greška, molimo pokušajte ponovno za par trenutaka'
                    })
                    break
                case 500:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Došlo je do greške na poslužitelju, molimo pokušajte ponovno'
                    })
                    break
                default:
                    return res.data
            }
        })
    },
    fetchuposleniciAutori(id) {
        return axios.get(`registar_v2/radovi/${id}/uposleniciAutori?perPage=-1`).then(res => {
            let resCode = res.status
            switch (resCode) {
                case 200:
                    return res.data
                case 201:
                    return res.data
                case 204:
                    return res.data
                case 404:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Dogodila se greška, molimo pokušajte ponovno za par trenutaka'
                    })
                    break
                case 500:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Došlo je do greške na poslužitelju, molimo pokušajte ponovno'
                    })
                    break
                default:
                    return res.data
            }
        })
    },
    fetchstraniAutori(id) {
        return axios.get(`registar_v2/radovi/${id}/straniAutori?perPage=-1`).then(res => {
            let resCode = res.status
            switch (resCode) {
                case 200:
                    return res.data
                case 201:
                    return res.data
                case 204:
                    return res.data
                case 404:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Dogodila se greška, molimo pokušajte ponovno za par trenutaka'
                    })
                    break
                case 500:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Došlo je do greške na poslužitelju, molimo pokušajte ponovno'
                    })
                    break
                default:
                    return res.data
            }
        })
    },
    fetchstudentiAutori(id) {
        return axios.get(`registar_v2/radovi/${id}/studentiAutori?perPage=-1`).then(res => {
            let resCode = res.status
            switch (resCode) {
                case 200:
                    return res.data
                case 201:
                    return res.data
                case 204:
                    return res.data
                case 404:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Dogodila se greška, molimo pokušajte ponovno za par trenutaka'
                    })
                    break
                case 500:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Došlo je do greške na poslužitelju, molimo pokušajte ponovno'
                    })
                    break
                default:
                    return res.data
            }
        })
    },
    fetchizdanje(id) {
        return axios.get(`registar_v2/radovi/${id}/izdanje?perPage=-1`).then(res => {
            let resCode = res.status
            switch (resCode) {
                case 200:
                    return res.data
                case 201:
                    return res.data
                case 204:
                    return res.data
                case 404:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Dogodila se greška, molimo pokušajte ponovno za par trenutaka'
                    })
                    break
                case 500:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Došlo je do greške na poslužitelju, molimo pokušajte ponovno'
                    })
                    break
                default:
                    return res.data
            }
        })
    },
    fetchlinkovi(id) {
        return axios.get(`registar_v2/radovi/${id}/linkovi?perPage=-1`).then(res => {
            let resCode = res.status
            switch (resCode) {
                case 200:
                    return res.data
                case 201:
                    return res.data
                case 204:
                    return res.data
                case 404:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Dogodila se greška, molimo pokušajte ponovno za par trenutaka'
                    })
                    break
                case 500:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Došlo je do greške na poslužitelju, molimo pokušajte ponovno'
                    })
                    break
                default:
                    return res.data
            }
        })
    },
    fetchdokumenti(id) {
        return axios.get(`registar_v2/radovi/${id}/dokumenti?perPage=-1`).then(res => {
            let resCode = res.status
            switch (resCode) {
                case 200:
                    return res.data
                case 201:
                    return res.data
                case 204:
                    return res.data
                case 404:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Dogodila se greška, molimo pokušajte ponovno za par trenutaka'
                    })
                    break
                case 500:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Došlo je do greške na poslužitelju, molimo pokušajte ponovno'
                    })
                    break
                default:
                    return res.data
            }
        })
    },
    fetchvrstaRada(id) {
        return axios.get(`registar_v2/radovi/${id}/vrstaRada?perPage=-1`).then(res => {
            let resCode = res.status
            switch (resCode) {
                case 200:
                    return res.data
                case 201:
                    return res.data
                case 204:
                    return res.data
                case 404:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Dogodila se greška, molimo pokušajte ponovno za par trenutaka'
                    })
                    break
                case 500:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Došlo je do greške na poslužitelju, molimo pokušajte ponovno'
                    })
                    break
                default:
                    return res.data
            }
        })
    },
    fetchKljucneRijeci(id) {
        return axios.get(`registar_v2/radovi/${id}/kljucneRijeci?perPage=-1`).then(res => {
            let resCode = res.status
            switch (resCode) {
                case 200:
                    return res.data
                case 201:
                    return res.data
                case 204:
                    return res.data
                case 404:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Dogodila se greška, molimo pokušajte ponovno za par trenutaka'
                    })
                    break
                case 500:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Došlo je do greške na poslužitelju, molimo pokušajte ponovno'
                    })
                    break
                default:
                    return res.data
            }
        })
    },
    fetchznanstvenaPodrucja(id) {
        return axios.get(`registar_v2/radovi/${id}/znanstvenaPodrucja?perPage=-1`).then(res => {
            let resCode = res.status
            switch (resCode) {
                case 200:
                    return res.data
                case 201:
                    return res.data
                case 204:
                    return res.data
                case 404:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Dogodila se greška, molimo pokušajte ponovno za par trenutaka'
                    })
                    break
                case 500:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Došlo je do greške na poslužitelju, molimo pokušajte ponovno'
                    })
                    break
                default:
                    return res.data
            }
        })
    },//
    fetchPrijevodi(id) {
        return axios.get(`registar_v2/radovi/${id}/prijevodi?perPage=-1`).then(res => {
            let resCode = res.status
            switch (resCode) {
                case 200:
                    return res.data
                case 201:
                    return res.data
                case 204:
                    return res.data
                case 404:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Dogodila se greška, molimo pokušajte ponovno za par trenutaka'
                    })
                    break
                case 500:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Došlo je do greške na poslužitelju, molimo pokušajte ponovno'
                    })
                    break
                default:
                    return res.data
            }
        })
    },
    deleteRad(id) {
        return axios.delete(`registar_v2/radovi/${id}`).then(res => {
            let resCode = res.status
            switch (resCode) {
                case 200:
                    return res.data
                case 201:
                    return res.data
                case 204:
                    return res.data
                case 404:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Dogodila se greška, molimo pokušajte ponovno za par trenutaka'
                    })
                    break
                case 500:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Došlo je do greške na poslužitelju, molimo pokušajte ponovno'
                    })
                    break
                default:
                    return res.data
            }
        })
    },
    getIzdanjaBaze(id) {
        return axios.get(`registar_v2/izdanja/${id}/bazeIzdanja?perPage=-1`).then(res => {
            let resCode = res.status
            switch (resCode) {
                case 200:
                    return res.data
                case 201:
                    return res.data
                case 204:
                    return res.data
                case 404:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Dogodila se greška, molimo pokušajte ponovno za par trenutaka'
                    })
                    break
                case 500:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Došlo je do greške na poslužitelju, molimo pokušajte ponovno'
                    })
                    break
                default:
                    return res.data
            }
        })
    },
    getIzdanjaIzdavaci(id) {
        return axios.get(`registar_v2/izdanja/${id}/Izdavaci?perPage=-1`).then(res => {
            let resCode = res.status
            switch (resCode) {
                case 200:
                    return res.data
                case 201:
                    return res.data
                case 204:
                    return res.data
                case 404:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Dogodila se greška, molimo pokušajte ponovno za par trenutaka'
                    })
                    break
                case 500:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Došlo je do greške na poslužitelju, molimo pokušajte ponovno'
                    })
                    break
                default:
                    return res.data
            }
        })
    },
    detachIzdanjaBaze(params) {
        return axios.post(`registar_v2/izdanja/${params.id}/bazeIzdanja`, {
            method: "detach",
            data: params.ids
        }).then(res => {
            let resCode = res.status
            switch (resCode) {
                case 200:
                    return res.data
                case 201:
                    return res.data
                case 204:
                    return res.data
                case 404:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Dogodila se greška, molimo pokušajte ponovno za par trenutaka'
                    })
                    break
                case 500:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Došlo je do greške na poslužitelju, molimo pokušajte ponovno'
                    })
                    break
                default:
                    return res.data
            }
        })
    },
    detachIzdanjaIzdavaci(params) {
        return axios.post(`registar_v2/izdanja/${params.id}/Izdavaci`, {
            method: "detach",
            data: params.ids
        }).then(res => {
            let resCode = res.status
            switch (resCode) {
                case 200:
                    return res.data
                case 201:
                    return res.data
                case 204:
                    return res.data
                case 404:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Dogodila se greška, molimo pokušajte ponovno za par trenutaka'
                    })
                    break
                case 500:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Došlo je do greške na poslužitelju, molimo pokušajte ponovno'
                    })
                    break
                default:
                    return res.data
            }
        })
    },
    verificirajRad(rad) {
        return axios.put(`/registar_v2/radovi/${rad.id}`,
            rad
        ).then(res => {
            let resCode = res.status
            switch (resCode) {
                case 200:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'green',
                        text: 'Rad uspješno verificiran!'
                    })
                    return res.data
                case 201:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'green',
                        text: 'Rad uspješno verificiran'
                    })
                    return res.data
                case 204:
                    return res.data
                case 404:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Dogodila se greška, molimo pokušajte ponovno za par trenutaka'
                    })
                    break
                case 500:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Došlo je do greške na poslužitelju, molimo pokušajte ponovno'
                    })
                    break
                default:
                    return res.data
            }
        })
    },
    urediLinkove(linkId) {
        return axios.delete(`registar_v2/linkovi_rada/${linkId}`
        ).then(res => {
            let resCode = res.status
            switch (resCode) {
                case 200:

                    return res.data
                case 201:

                    return res.data
                case 204:
                    return res.data
                case 404:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Dogodila se greška, molimo pokušajte ponovno za par trenutaka'
                    })
                    break
                case 500:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Došlo je do greške na poslužitelju, molimo pokušajte ponovno'
                    })
                    break
                default:
                    return res.data
            }
        })
    },
    izbrisiOdabraniPrijevod(prijevodId) {
        return axios.delete(`registar_v2/prijevodi_rada/${prijevodId}`
        ).then(res => {
            let resCode = res.status
            switch (resCode) {
                case 200:

                    return res.data
                case 201:

                    return res.data
                case 204:
                    return res.data
                case 404:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Dogodila se greška, molimo pokušajte ponovno za par trenutaka'
                    })
                    break
                case 500:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Došlo je do greške na poslužitelju, molimo pokušajte ponovno'
                    })
                    break
                default:
                    return res.data
            }
        })
    },
    izbrisiOdabraniDokument(dokumentId) {
        return axios.delete(`files/${dokumentId}`
        ).then(res => {
            let resCode = res.status
            switch (resCode) {
                case 200:

                    return res.data
                case 201:

                    return res.data
                case 204:
                    return res.data
                case 404:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Dogodila se greška, molimo pokušajte ponovno za par trenutaka'
                    })
                    break
                case 500:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Došlo je do greške na poslužitelju, molimo pokušajte ponovno'
                    })
                    break
                default:
                    return res.data
            }
        })
    },
    urediRad(rad) {
        return axios.put(`/registar_v2/radovi/${rad.id}`,
            rad
        ).then(res => {
            let resCode = res.status
            switch (resCode) {
                case 200:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'green',
                        text: 'Rad uspješno uređen!'
                    })
                    return res.data
                case 201:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'green',
                        text: 'Rad uspješno uređen!'
                    })
                    return res.data
                case 204:
                    return res.data
                case 404:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Dogodila se greška, molimo pokušajte ponovno za par trenutaka'
                    })
                    break
                case 500:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Došlo je do greške na poslužitelju, molimo pokušajte ponovno'
                    })
                    break
                default:
                    return res.data
            }
        })
    },
    detachuposleniciAutori(params) {
        return axios.post(`registar_v2/radovi/${params.id}/uposleniciAutori`, {
            method: "detach",
            data: params.ids
        }).then(res => {
            let resCode = res.status
            switch (resCode) {
                case 200:
                    return res.data
                case 201:
                    return res.data
                case 204:
                    return res.data
                case 404:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Dogodila se greška, molimo pokušajte ponovno za par trenutaka'
                    })
                    break
                case 500:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Došlo je do greške na poslužitelju, molimo pokušajte ponovno'
                    })
                    break
                default:
                    return res.data
            }
        })
    },
    detachstraniAutori(params) {
        return axios.post(`registar_v2/radovi/${params.id}/straniAutori`, {
            method: "detach",
            data: params.ids
        }).then(res => {
            let resCode = res.status
            switch (resCode) {
                case 200:
                    return res.data
                case 201:
                    return res.data
                case 204:
                    return res.data
                case 404:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Dogodila se greška, molimo pokušajte ponovno za par trenutaka'
                    })
                    break
                case 500:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Došlo je do greške na poslužitelju, molimo pokušajte ponovno'
                    })
                    break
                default:
                    return res.data
            }
        })
    },
    detachstudentiAutori(params) {
        return axios.post(`registar_v2/radovi/${params.id}/studentiAutori`, {
            method: "detach",
            data: params.ids
        }).then(res => {
            let resCode = res.status
            switch (resCode) {
                case 200:
                    return res.data
                case 201:
                    return res.data
                case 204:
                    return res.data
                case 404:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Dogodila se greška, molimo pokušajte ponovno za par trenutaka'
                    })
                    break
                case 500:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Došlo je do greške na poslužitelju, molimo pokušajte ponovno'
                    })
                    break
                default:
                    return res.data
            }
        })
    },
    detachlinkovi(params) {
        return axios.post(`/registar_v2/radovi/${params.id}/linkovi`, {
            method: "delete",
            data: null
        }).then(res => {
            let resCode = res.status
            switch (resCode) {
                case 200:
                    return res.data
                case 201:
                    return res.data
                case 204:
                    return res.data
                case 404:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Dogodila se greška, molimo pokušajte ponovno za par trenutaka'
                    })
                    break
                case 500:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Došlo je do greške na poslužitelju, molimo pokušajte ponovno'
                    })
                    break
                default:
                    return res.data
            }
        })
    },
    detachdokumenti(params) {
        return axios.post(`registar_v2/radovi/${params.id}/dokumentiRada`, {
            method: "delete",
            data: null
        }).then(res => {
            let resCode = res.status
            switch (resCode) {
                case 200:
                    return res.data
                case 201:
                    return res.data
                case 204:
                    return res.data
                case 404:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Dogodila se greška, molimo pokušajte ponovno za par trenutaka'
                    })
                    break
                case 500:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Došlo je do greške na poslužitelju, molimo pokušajte ponovno'
                    })
                    break
                default:
                    return res.data
            }
        })
    },
    detachvrstaRada(params) {
        return axios.post(`registar_v2/radovi/${params.id}/vrstaRada`, {
            method: "detach",
            data: params.ids
        }).then(res => {
            let resCode = res.status
            switch (resCode) {
                case 200:
                    return res.data
                case 201:
                    return res.data
                case 204:
                    return res.data
                case 404:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Dogodila se greška, molimo pokušajte ponovno za par trenutaka'
                    })
                    break
                case 500:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Došlo je do greške na poslužitelju, molimo pokušajte ponovno'
                    })
                    break
                default:
                    return res.data
            }
        })
    },
    detachizdanje(params) {
        return axios.post(`registar_v2/radovi/${params.id}/izdanje`, {
            method: "detach",
            data: params.ids
        }).then(res => {
            let resCode = res.status
            switch (resCode) {
                case 200:
                    return res.data
                case 201:
                    return res.data
                case 204:
                    return res.data
                case 404:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Dogodila se greška, molimo pokušajte ponovno za par trenutaka'
                    })
                    break
                case 500:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Došlo je do greške na poslužitelju, molimo pokušajte ponovno'
                    })
                    break
                default:
                    return res.data
            }
        })
    },
    detachKljucneRijeci(params) {
        return axios.post(`registar_v2/radovi/${params.id}/kljucneRijeci`, {
            method: "detach",
            data: params.ids
        }).then(res => {
            let resCode = res.status
            switch (resCode) {
                case 200:
                    return res.data
                case 201:
                    return res.data
                case 204:
                    return res.data
                case 404:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Dogodila se greška, molimo pokušajte ponovno za par trenutaka'
                    })
                    break
                case 500:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Došlo je do greške na poslužitelju, molimo pokušajte ponovno'
                    })
                    break
                default:
                    return res.data
            }
        })
    },
    detachznanstvenaPodrucja(params) {
        return axios.post(`registar_v2/radovi/${params.id}/znanstvenaPodrucja`, {
            method: "detach",
            data: params.ids
        }).then(res => {
            let resCode = res.status
            switch (resCode) {
                case 200:
                    return res.data
                case 201:
                    return res.data
                case 204:
                    return res.data
                case 404:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Dogodila se greška, molimo pokušajte ponovno za par trenutaka'
                    })
                    break
                case 500:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Došlo je do greške na poslužitelju, molimo pokušajte ponovno'
                    })
                    break
                default:
                    return res.data
            }
        })
    },//
    detachPrijevodi(params) {
        return axios.post(`registar_v2/radovi/${params.id}/prijevodi`, {
            method: "delete",
            data: null
        }).then(res => {
            let resCode = res.status
            switch (resCode) {
                case 200:
                    return res.data
                case 201:
                    return res.data
                case 204:
                    return res.data
                case 404:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Dogodila se greška, molimo pokušajte ponovno za par trenutaka'
                    })
                    break
                case 500:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Došlo je do greške na poslužitelju, molimo pokušajte ponovno'
                    })
                    break
                default:
                    return res.data
            }
        })
    },
    logout() {
        window.location.href = `https://api.sum.ba/sso/logout?redirect_to=http://pub.sum.ba`
        // axios.get('/sso/logout')
    },
    getAuthorHints(search){
        console.log(search)
        return axios.post(`registar_v2/strani_autori${search}`, {
            method: "get",
            data: null
        }).then(res => {
            let resCode = res.status
            switch (resCode) {
                case 200:
                    return res.data
                case 201:
                    return res.data
                case 204:
                    return res.data
                case 404:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Dogodila se greška, molimo pokušajte ponovno za par trenutaka'
                    })
                    break
                case 500:
                    store.dispatch('getNotification', {
                        state: true,
                        color: 'red',
                        text: 'Došlo je do greške na poslužitelju, molimo pokušajte ponovno'
                    })
                    break
                default:
                    return res.data
            }
        })
    },
}








